<template lang="pug">
el-dialog(v-draggable, width="450px", title="编号规则", :visible.sync="visible", :close-on-click-modal="false", @closed="$destroy()")
  el-form(label-width="90px", size="small", :disabled="readonly")
    el-form-item.mb-8(label="规则名称")
      el-input(v-model.trim="ruleName", clearable, :maxlength="20", show-limit-word)
    components(:list="list", :is="container", tag="transition-group", :animation="200", handle=".move")
      .drag-item(v-for="item in tagList", :key="item.id")
        .move
          i.el-icon-rank(v-if="editMode")
        .drag-label {{ item.cnName }}
        components.item-container(:is="item.component", :data="item.data", :columns="columns", :time-formats="timeFormats")
        i.el-icon-delete.delete(v-if="editMode", @click="deleteItem(item)")
  template(#footer)
    el-dropdown.mr-12(v-if="editMode", @command="addOption")
      el-button(type="primary", size="mini") 添加
        i.el-icon-arrow-down.el-icon--right
      template(#dropdown)
        el-dropdown-menu
          el-dropdown-item(v-for="{ id, cnName } in options", :key="id", :command="id") {{ cnName }}
    el-button(@click="close()" size="small") 关闭
    el-button(v-if="editMode", type="primary", @click="submit()" size="small") 保存
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import draggable from "vuedraggable";
import { itemList, TYPE_ENUM } from "./index.js";
import service from "@/CommonDP/service/metadata-service.js";
import { asyncMixin } from "@/CommonDP/commons/asyncCom.js";
import { serialNo_rule_details, serialNo_rule_saveOrUpdate } from "@/CommonDP/service/serialNo-rule.js";
import { getVfDictItems } from "@/CommonDP/service/vf-component-service.js";
export default {
  mixins: [asyncMixin],
  props: {
    tableName: { default: "", type: String },
    readonly: { default: false, type: Boolean },
    ruleId: { default: "", type: String }
  },
  data() {
    return {
      visible: false,
      list: [],
      columns: [],
      ruleName: "",
      timeFormats: []
    };
  },
  computed: {
    container() {
      return this.readonly ? "div" : draggable;
    },
    editMode() {
      return !this.readonly;
    },
    tagList() {
      const { list } = this;
      return list.map((item) => {
        const { component, cnName } = this.getItem(item.type);
        return { ...item, component, cnName };
      });
    },
    options() {
      return itemList;
    },
    submitData() {
      const { ruleName, ruleId, list } = this;
      return {
        ruleName,
        ruleId: ruleId || undefined,
        ruleList: list.map(({ data }) => data)
      };
    }
  },
  async created() {
    await Promise.all([this.getTable(), this.getDetail(), this.getTimeFormat()]);
    this.open();
  },
  methods: {
    async getTimeFormat() {
      const { data } = await getVfDictItems({ dicCode: "SerialNoDateFormat" });
      this.timeFormats = data;
    },
    async getDetail() {
      const { ruleId } = this;
      if (!ruleId) return;
      const {
        data: { ruleName, ruleList }
      } = await serialNo_rule_details(ruleId);
      this.ruleName = ruleName;
      this.list = ruleList.map((data) => ({ type: data.contentType, id: data.sid, data }));
    },
    async getTable() {
      const { tableName } = this;
      if (tableName) {
        const { data } = await service.columnList(tableName);
        this.columns = data;
      }
    },
    getItem(type) {
      return itemList.find(({ id }) => id === type);
    },
    async addOption(type) {
      const item = this.getItem(type);
      await item.component();
      await this.$nextTick();
      const id = Date.now();
      const data = cloneDeep(item.raw);
      data.contentType = type;
      if (type === TYPE_ENUM.time) data.contentFormat = this.timeFormats[0]?.cnname;
      this.list.push({ type, id, data });
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    validate() {
      // const { list } = this;
      // const hasR = list.some(({ type }) => type === TYPE_ENUM.number);
      // if (!hasR) {
      //   const str = "至少包含一个" + this.getItem(TYPE_ENUM.number).cnName;
      //   this.$message.warning(str);
      //   throw new Error(str);
      // }
    },
    async submit() {
      this.validate();
      const { data } = await serialNo_rule_saveOrUpdate(this.submitData);
      this.resolve(data);
      this.visible = false;
    },
    async deleteItem(item) {
      await this.$confirm("确定删除", { type: "warning" });
      this.list = this.list.filter(({ id }) => id !== item.id);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
